export const hasVenueSetupBeenCompleted = venue => {
  const hasStripe = venue.stripe_token && venue.stripe_token !== '';
  return (
    venue.has_created_menu &&
    hasStripe &&
    venue.has_first_order &&
    venue.has_visited_settings
  );
};



// WEBPACK FOOTER //
// ./src/utils/venue/venue.js